<div class="payment-list-item"
     tabindex="0"
     role="button"
     [attr.aria-label]="i18n?.i18nLng()[paymentListItem?.name]"
     (click)="itemClicked.emit(paymentListItem)"
     (keydown.enter)="itemClicked.emit(paymentListItem)"
     (keydown.space)="itemClicked.emit(paymentListItem)">
  <div class="icon-container icon" [ngClass]="(paymentListItem?.hasPaymentTypes && paymentListItem?.paymentTypeCount.LIVE > 0)  ? 'active' : ((paymentListItem?.paymentTypeCount.CLOSED > 0 && paymentListItem?.paymentTypeCount.LIVE === 0 && paymentListItem?.paymentTypeCount.TEST === 0) || paymentListItem?.lockedByTenant ||  paymentListItem?.lockedByAdmin) ? 'canceled' : null">
    @if (!paymentListItem?.customIcon) {
      <i class="icon" [ngClass]="paymentListItem?.icon"></i>
    } @else {
      <sps-custom-icon [name]="paymentListItem?.icon" [size]="21"></sps-custom-icon>
    }
  </div>
  <div class="title-container">
    <div class="title">
      {{ i18n?.i18nLng()[paymentListItem?.name] }}
    </div>
    <div class="title subtitle flex-row">
      @if (paymentListItem?.paymentTypeCount?.LIVE > 0) {
        {{ i18n.i18nLng()['LIVE'] }}:&nbsp;{{ paymentListItem?.paymentTypeCount?.LIVE }}
        @if ((paymentListItem?.paymentTypeCount?.TEST + paymentListItem?.paymentTypeCount?.CLOSED > 0)) {
          <div class="divider">•</div>
        }
      }
      @if (paymentListItem?.paymentTypeCount?.TEST > 0) {
        {{ i18n.i18nLng()['TEST'] }}:&nbsp;{{ paymentListItem?.paymentTypeCount?.TEST }}
        @if (paymentListItem?.paymentTypeCount?.CLOSED > 0) {
          <div class="divider">•</div>
        }
      }
      @if (paymentListItem?.paymentTypeCount?.CLOSED > 0) {
        {{ i18n.i18nLng()['CLOSED'] }}&nbsp;{{ paymentListItem?.paymentTypeCount?.CLOSED }}
      }
   </div>
  </div>
  <div class="button-container">
    <i class="pi pi-angle-right"></i>
  </div>
</div>

